(function () {
  function initTrackProMainProduct(root) {
    const sections = root.querySelectorAll('[data-tp-main-section]');
    const mobileMediaQuery = window.matchMedia('(max-width: 989px)');

    sections.forEach((section) => {
      if (section.dataset.tpReady === 'true') return;
      section.dataset.tpReady = 'true';

      const featuredItems = Array.from(section.querySelectorAll('[data-tp-featured-item]'));
      const thumbs = Array.from(section.querySelectorAll('[data-tp-thumb]'));
      const offerCards = Array.from(section.querySelectorAll('[data-tp-offer-card]'));
      const accordions = Array.from(section.querySelectorAll('[data-tp-accordion]'));
      const reviewAnchors = Array.from(section.querySelectorAll('[data-tp-scroll-target]'));
      const variantInput = section.querySelector('[data-tp-variant-input]');
      const priceNode = section.querySelector('[data-tp-current-price]');
      const compareNode = section.querySelector('[data-tp-current-compare]');
      const discountNode = section.querySelector('[data-tp-current-discount]');
      const submitButton = section.querySelector('[data-tp-submit]');
      const submitText = section.querySelector('[data-tp-submit-text]');
      const slideCurrentNode = section.querySelector('[data-tp-slide-current]');
      const mainSwiperElement = section.querySelector('[data-tp-main-swiper]');
      const thumbsSwiperElement = section.querySelector('[data-tp-thumbs-swiper]');
      const mainPrevButton = section.querySelector('[data-tp-main-prev]');
      const mainNextButton = section.querySelector('[data-tp-main-next]');
      const lightbox = section.querySelector('[data-tp-lightbox]');
      const lightboxMedia = lightbox && lightbox.querySelector('[data-tp-lightbox-media]');
      const lightboxPan = lightbox && lightbox.querySelector('[data-tp-lightbox-pan]');
      const lightboxImage = lightbox && lightbox.querySelector('.tp-main-product__lightbox-image');
      const lightboxPrevButton = section.querySelector('[data-tp-lightbox-prev]');
      const lightboxNextButton = section.querySelector('[data-tp-lightbox-next]');
      const lightboxCurrentNode = section.querySelector('[data-tp-lightbox-current]');
      const lightboxCloseButtons = Array.from(section.querySelectorAll('[data-tp-lightbox-close]'));
      const openLightboxButtons = Array.from(section.querySelectorAll('[data-tp-open-lightbox]'));
      const zoomInButton = section.querySelector('[data-tp-lightbox-zoom-in]');
      const zoomOutButton = section.querySelector('[data-tp-lightbox-zoom-out]');
      const zoomResetButton = section.querySelector('[data-tp-lightbox-zoom-reset]');
      const accordionAnimations = new WeakMap();
      const body = document.body;

      let mainSwiper = null;
      let thumbsSwiper = null;
      let activeMainIndex = 0;
      let lastFocusedElement = null;
      let pointerDrag = null;
      let touchDrag = null;
      let pinchState = null;
      let lastTapState = {
        time: 0,
        x: 0,
        y: 0,
      };

      const zoomState = {
        scale: 1,
        x: 0,
        y: 0,
      };

      if (lightbox && lightbox.parentNode !== body) {
        body.appendChild(lightbox);
      }

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
      const getDistance = (touchA, touchB) => Math.hypot(touchB.clientX - touchA.clientX, touchB.clientY - touchA.clientY);

      const getMediaIndexById = (mediaId) =>
        featuredItems.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));

      const getMediaIdByIndex = (index) => {
        const target = featuredItems[index];
        return target ? String(target.dataset.mediaId) : '';
      };

      const getSafeMainIndex = (index) => {
        const maxIndex = Math.max(featuredItems.length - 1, 0);
        return clamp(typeof index === 'number' ? index : 0, 0, maxIndex);
      };

      const getMediaTypeByIndex = (index) => {
        const target = featuredItems[getSafeMainIndex(index)];
        return target ? target.dataset.mediaType || 'image' : 'image';
      };

      const isZoomableMedia = (index) => getMediaTypeByIndex(index) === 'image';

      const getNextZoomableIndex = (startIndex, direction) => {
        let nextIndex = getSafeMainIndex(startIndex) + direction;

        while (nextIndex >= 0 && nextIndex < featuredItems.length) {
          if (isZoomableMedia(nextIndex)) {
            return nextIndex;
          }

          nextIndex += direction;
        }

        return -1;
      };

      const isLightboxOpen = () => Boolean(lightbox && !lightbox.hidden);

      const getActiveMainIndex = () => getSafeMainIndex(activeMainIndex);

      const postMessageToFrame = (frame, payload) => {
        if (!frame || !frame.contentWindow) return;

        try {
          frame.contentWindow.postMessage(payload, '*');
        } catch (error) {
          // no-op
        }
      };

      const pauseMediaInContainer = (container) => {
        if (!container) return;

        container.querySelectorAll('video').forEach((video) => {
          video.pause();
        });

        container.querySelectorAll('.js-youtube').forEach((video) => {
          postMessageToFrame(video, '{"event":"command","func":"pauseVideo","args":""}');
        });

        container.querySelectorAll('.js-vimeo').forEach((video) => {
          postMessageToFrame(video, '{"method":"pause"}');
        });

        container.querySelectorAll('product-model').forEach((model) => {
          if (model.modelViewerUI) {
            model.modelViewerUI.pause();
          }
        });
      };

      const pauseSectionMedia = () => {
        pauseMediaInContainer(section);

        if (lightbox) {
          pauseMediaInContainer(lightbox);
        }
      };

      const loadDeferredMedia = (item) => {
        const deferredMedia = item && item.querySelector('[data-tp-deferred-media]');
        if (!deferredMedia || deferredMedia.hasAttribute('loaded') || typeof deferredMedia.loadContent !== 'function') {
          return;
        }

        deferredMedia.loadContent(false);
      };

      const playItemMedia = (item) => {
        if (!item) return;

        const video = item.querySelector('video');
        if (video) {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
          return;
        }

        const youtubeFrame = item.querySelector('.js-youtube');
        if (youtubeFrame) {
          postMessageToFrame(youtubeFrame, '{"event":"command","func":"playVideo","args":""}');
        }

        const vimeoFrame = item.querySelector('.js-vimeo');
        if (vimeoFrame) {
          postMessageToFrame(vimeoFrame, '{"method":"play"}');
        }
      };

      const syncActiveMedia = (index) => {
        pauseSectionMedia();

        const safeIndex = getSafeMainIndex(index);
        const item = featuredItems[safeIndex];
        if (!item) return;

        const mediaType = item.dataset.mediaType;
        if (mediaType !== 'video' && mediaType !== 'external_video') return;

        loadDeferredMedia(item);

        const triggerPlay = () => {
          if (getActiveMainIndex() !== safeIndex) return;
          playItemMedia(item);
        };

        triggerPlay();
        window.requestAnimationFrame(triggerPlay);
        window.setTimeout(triggerPlay, 180);
      };

      const updateZoomAvailability = (index) => {
        const canZoom = isZoomableMedia(index);

        openLightboxButtons.forEach((button) => {
          button.hidden = !canZoom;
          button.disabled = !canZoom;
          button.setAttribute('aria-hidden', canZoom ? 'false' : 'true');
        });
      };

      const updateLightboxNavigation = (index) => {
        const safeIndex = getSafeMainIndex(index);
        const previousZoomableIndex = getNextZoomableIndex(safeIndex, -1);
        const nextZoomableIndex = getNextZoomableIndex(safeIndex, 1);

        if (lightboxCurrentNode) {
          lightboxCurrentNode.textContent = String(safeIndex + 1);
        }

        if (lightboxPrevButton) {
          lightboxPrevButton.disabled = previousZoomableIndex === -1;
        }

        if (lightboxNextButton) {
          lightboxNextButton.disabled = nextZoomableIndex === -1;
        }
      };

      const updateActiveState = (activeIndex) => {
        const safeIndex = getSafeMainIndex(activeIndex);
        const activeMediaId = getMediaIdByIndex(safeIndex);
        activeMainIndex = safeIndex;

        featuredItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === safeIndex);
        });

        thumbs.forEach((thumb, index) => {
          const isActive = index === safeIndex || String(thumb.dataset.mediaId) === activeMediaId;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (slideCurrentNode) {
          slideCurrentNode.textContent = String(safeIndex + 1);
        }

        updateZoomAvailability(safeIndex);
        updateLightboxNavigation(safeIndex);
        syncActiveMedia(safeIndex);
      };

      const slideToMedia = (mediaId, options) => {
        const settings = Object.assign(
          {
            speed: 420,
          },
          options || {}
        );

        const nextIndex = getMediaIndexById(mediaId);
        if (nextIndex < 0) return;
        const previousIndex = getActiveMainIndex();

        updateActiveState(nextIndex);

        if (mainSwiper && mainSwiper.activeIndex !== nextIndex) {
          mainSwiper.slideTo(nextIndex, settings.speed);
        }

        if (thumbsSwiper && thumbsSwiper.activeIndex !== nextIndex) {
          thumbsSwiper.slideTo(nextIndex);
        }

        if (isLightboxOpen() && previousIndex !== nextIndex) {
          if (!isZoomableMedia(nextIndex)) {
            closeLightbox();
          } else {
            resetLightboxZoom({ animate: false });
            updateLightboxImage(nextIndex);
          }
        }
      };

      const updateZoomLabel = (scale) => {
        if (!zoomResetButton) return;
        const safeScale = Number(scale) > 0 ? Number(scale) : 1;
        zoomResetButton.textContent = `${Math.round(safeScale * 100)}%`;
        zoomResetButton.classList.toggle('is-active', safeScale > 1.01);
      };

      const clampZoomState = () => {
        if (!lightboxMedia || !lightboxImage) return;

        const viewportWidth = lightboxMedia.clientWidth;
        const viewportHeight = lightboxMedia.clientHeight;
        const baseWidth = lightboxImage.offsetWidth || viewportWidth;
        const baseHeight = lightboxImage.offsetHeight || viewportHeight;
        const maxX = Math.max((baseWidth * zoomState.scale - viewportWidth) / 2, 0);
        const maxY = Math.max((baseHeight * zoomState.scale - viewportHeight) / 2, 0);

        zoomState.x = clamp(zoomState.x, -maxX, maxX);
        zoomState.y = clamp(zoomState.y, -maxY, maxY);

        if (zoomState.scale <= 1.01) {
          zoomState.scale = 1;
          zoomState.x = 0;
          zoomState.y = 0;
        }
      };

      const applyZoomState = (options) => {
        const settings = Object.assign({ animate: true }, options || {});
        if (!lightboxPan || !lightboxMedia) return;

        clampZoomState();
        lightboxPan.style.transition = settings.animate ? '' : 'none';
        lightboxPan.style.transform = `translate3d(${zoomState.x}px, ${zoomState.y}px, 0) scale(${zoomState.scale})`;
        lightboxMedia.classList.toggle('is-zoomed', zoomState.scale > 1.01);
        updateZoomLabel(zoomState.scale);
      };

      const resetLightboxZoom = (options) => {
        const settings = Object.assign({ animate: true }, options || {});
        zoomState.scale = 1;
        zoomState.x = 0;
        zoomState.y = 0;
        pointerDrag = null;
        touchDrag = null;
        pinchState = null;

        if (lightboxPan) {
          lightboxPan.classList.remove('is-dragging');
        }

        applyZoomState({ animate: settings.animate });
      };

      const setLightboxZoom = (nextScale, options) => {
        const settings = Object.assign({ animate: true }, options || {});
        zoomState.scale = clamp(nextScale, 1, 5);

        if (zoomState.scale <= 1.01) {
          zoomState.scale = 1;
          zoomState.x = 0;
          zoomState.y = 0;
        }

        applyZoomState({ animate: settings.animate });
      };

      const updateLightboxImage = (index) => {
        if (!lightboxImage) return;

        const safeIndex = getSafeMainIndex(index);
        if (!isZoomableMedia(safeIndex)) return;

        const item = featuredItems[safeIndex];
        if (!item) return;

        const source = item.dataset.lightboxSrc || '';
        const alt = item.dataset.lightboxAlt || '';
        if (!source) return;

        lightboxImage.setAttribute('src', source);
        lightboxImage.setAttribute('srcset', source);

        lightboxImage.setAttribute('alt', alt);
        updateLightboxNavigation(safeIndex);
      };

      const setLightboxIndex = (nextIndex) => {
        const safeIndex = getSafeMainIndex(nextIndex);
        if (!isZoomableMedia(safeIndex)) {
          closeLightbox();
          return;
        }

        if (safeIndex === getActiveMainIndex()) {
          updateLightboxImage(safeIndex);
          return;
        }

        const mediaId = getMediaIdByIndex(safeIndex);
        if (mediaId) {
          slideToMedia(mediaId, { speed: 0 });
          return;
        }

        resetLightboxZoom({ animate: false });
        updateActiveState(safeIndex);
        updateLightboxImage(safeIndex);
      };

      const stepLightbox = (direction) => {
        const currentIndex = getActiveMainIndex();
        const nextIndex = getNextZoomableIndex(currentIndex, direction);
        if (nextIndex === -1) return;

        setLightboxIndex(nextIndex);
      };

      const openLightbox = (targetIndex) => {
        if (!lightbox || !lightboxImage) return;

        const safeIndex =
          typeof targetIndex === 'number' && !Number.isNaN(targetIndex) ? getSafeMainIndex(targetIndex) : getActiveMainIndex();
        if (!isZoomableMedia(safeIndex)) return;

        lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        updateActiveState(safeIndex);
        updateLightboxImage(safeIndex);
        resetLightboxZoom({ animate: false });

        if (mainSwiper && mainSwiper.keyboard && typeof mainSwiper.keyboard.disable === 'function') {
          mainSwiper.keyboard.disable();
        }

        lightbox.hidden = false;
        lightbox.classList.add('is-open');
        body.classList.add('tp-main-product--lightbox-open');

        window.requestAnimationFrame(() => {
          applyZoomState({ animate: false });

          const focusTarget = lightbox.querySelector('.tp-main-product__lightbox-close');
          if (focusTarget) {
            focusTarget.focus({ preventScroll: true });
          }
        });
      };

      const closeLightbox = () => {
        if (!lightbox || lightbox.hidden) return;

        resetLightboxZoom({ animate: false });
        lightbox.classList.remove('is-open');
        lightbox.hidden = true;
        body.classList.remove('tp-main-product--lightbox-open');
        lastTapState.time = 0;

        if (mainSwiper && mainSwiper.keyboard && typeof mainSwiper.keyboard.enable === 'function') {
          mainSwiper.keyboard.enable();
        }

        if (lastFocusedElement && document.contains(lastFocusedElement)) {
          lastFocusedElement.focus({ preventScroll: true });
        }
      };

      const stopAccordionAnimation = (accordion) => {
        const animation = accordionAnimations.get(accordion);
        const content = accordion.querySelector('[data-tp-accordion-content]');
        if (animation && content) {
          content.removeEventListener('transitionend', animation.onTransitionEnd);
          content.style.transition = '';
          if (animation.frame) {
            window.cancelAnimationFrame(animation.frame);
          }
        }
        accordionAnimations.delete(accordion);
      };

      const setAccordionOpen = (accordion, shouldOpen, skipAnimation) => {
        const trigger = accordion.querySelector('[data-tp-accordion-trigger]');
        const content = accordion.querySelector('[data-tp-accordion-content]');
        if (!trigger || !content) return;

        const inner = content.firstElementChild;
        if (!inner) return;

        stopAccordionAnimation(accordion);
        content.style.overflow = 'hidden';
        const openHeight = inner.scrollHeight;

        if (skipAnimation) {
          accordion.classList.toggle('is-open', shouldOpen);
          trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          content.style.height = shouldOpen ? `${openHeight}px` : '0px';
          return;
        }

        const startHeight = content.getBoundingClientRect().height;
        const endHeight = shouldOpen ? openHeight : 0;

        if (startHeight === endHeight) {
          accordion.classList.toggle('is-open', shouldOpen);
          trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          content.style.height = shouldOpen ? `${openHeight}px` : '0px';
          return;
        }

        content.style.transition = 'none';
        content.style.height = `${startHeight}px`;
        content.offsetHeight;

        accordion.classList.toggle('is-open', shouldOpen);
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

        const handleTransitionEnd = (event) => {
          if (event.propertyName !== 'height') return;
          content.style.transition = '';
          content.style.height = accordion.classList.contains('is-open') ? `${inner.scrollHeight}px` : '0px';
          content.removeEventListener('transitionend', handleTransitionEnd);
          accordionAnimations.delete(accordion);
        };

        const frame = window.requestAnimationFrame(() => {
          content.style.transition = 'height 320ms cubic-bezier(0.22, 1, 0.36, 1)';
          content.style.height = `${endHeight}px`;
        });

        accordionAnimations.set(accordion, { onTransitionEnd: handleTransitionEnd, frame });
        content.addEventListener('transitionend', handleTransitionEnd);
      };

      const syncAccordionHeight = (accordion) => {
        const content = accordion.querySelector('[data-tp-accordion-content]');
        const inner = content && content.firstElementChild;
        if (!content || !inner) return;
        stopAccordionAnimation(accordion);
        content.style.height = accordion.classList.contains('is-open') ? `${inner.scrollHeight}px` : '0px';
      };

      if (window.Swiper && mainSwiperElement && featuredItems.length) {
        const initialMediaId = mainSwiperElement.dataset.initialMediaId || getMediaIdByIndex(0);
        const initialSlide = Math.max(getMediaIndexById(initialMediaId), 0);

        if (thumbsSwiperElement && thumbs.length > 1) {
          thumbsSwiper = new window.Swiper(thumbsSwiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            breakpoints: {
              0: {
                spaceBetween: 8,
              },
              750: {
                spaceBetween: 12,
              },
            },
            freeMode: true,
            watchOverflow: true,
            watchSlidesProgress: true,
          });
        }

        mainSwiper = new window.Swiper(mainSwiperElement, {
          initialSlide,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 420,
          watchOverflow: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          navigation:
            mainPrevButton && mainNextButton
              ? {
                  prevEl: mainPrevButton,
                  nextEl: mainNextButton,
                }
              : undefined,
          on: {
            init(swiper) {
              updateActiveState(swiper.activeIndex);
              section.classList.add('is-swiper-ready');
              if (thumbsSwiper && thumbsSwiper.activeIndex !== swiper.activeIndex) {
                thumbsSwiper.slideTo(swiper.activeIndex, 0);
              }
            },
            slideChange(swiper) {
              updateActiveState(swiper.activeIndex);

              if (thumbsSwiper && thumbsSwiper.activeIndex !== swiper.activeIndex) {
                thumbsSwiper.slideTo(swiper.activeIndex);
              }
            },
            doubleTap(swiper, event) {
              if (!mobileMediaQuery.matches) return;
              if (event && event.target && event.target.closest('[data-tp-open-lightbox]')) return;
              if (!isZoomableMedia(swiper.activeIndex)) return;
              openLightbox(swiper.activeIndex);
            },
          },
        });

        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            slideToMedia(thumb.dataset.mediaId);
          });
        });
      } else {
        updateActiveState(0);
      }

      if (lightboxImage) {
        lightboxImage.addEventListener('load', () => {
          resetLightboxZoom({ animate: false });
        });
      }

      if (lightboxMedia) {
        const toggleTapZoom = () => {
          const nextScale = zoomState.scale > 1.01 ? 1 : 2.5;
          setLightboxZoom(nextScale);
        };

        lightboxMedia.addEventListener('dblclick', (event) => {
          if (!lightbox || lightbox.hidden) return;
          event.preventDefault();
          toggleTapZoom();
        });

        lightboxMedia.addEventListener(
          'touchstart',
          (event) => {
            if (!lightbox || lightbox.hidden) return;

            if (event.touches.length === 2) {
              pinchState = {
                startDistance: getDistance(event.touches[0], event.touches[1]),
                startScale: zoomState.scale,
              };
              touchDrag = null;
              event.preventDefault();
              return;
            }

            if (event.touches.length === 1) {
              const touch = event.touches[0];
              touchDrag = {
                startX: touch.clientX,
                startY: touch.clientY,
                originX: zoomState.x,
                originY: zoomState.y,
                gesture: zoomState.scale > 1.01 ? 'pan' : null,
                moved: false,
              };
            }
          },
          { passive: false }
        );

        lightboxMedia.addEventListener(
          'touchmove',
          (event) => {
            if (!lightbox || lightbox.hidden) return;

            if (pinchState && event.touches.length === 2) {
              const distance = getDistance(event.touches[0], event.touches[1]);
              zoomState.scale = clamp((distance / pinchState.startDistance) * pinchState.startScale, 1, 5);
              applyZoomState({ animate: false });
              event.preventDefault();
              return;
            }

            if (!touchDrag || event.touches.length !== 1) return;

            const touch = event.touches[0];
            const deltaX = touch.clientX - touchDrag.startX;
            const deltaY = touch.clientY - touchDrag.startY;

            if (zoomState.scale > 1.01 || touchDrag.gesture === 'pan') {
              if (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6) {
                touchDrag.moved = true;
              }

              touchDrag.gesture = 'pan';

              if (lightboxPan) {
                lightboxPan.classList.add('is-dragging');
              }

              zoomState.x = touchDrag.originX + deltaX;
              zoomState.y = touchDrag.originY + deltaY;
              applyZoomState({ animate: false });
              event.preventDefault();
              return;
            }

            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);

            if (absX > 10 || absY > 10) {
              touchDrag.moved = true;
            }

            if (!touchDrag.gesture) {
              if (absX < 10 && absY < 10) return;
              touchDrag.gesture = absX > absY ? 'swipe' : 'ignore';
            }

            if (touchDrag.gesture !== 'swipe' || !lightboxPan || featuredItems.length < 2) return;

            lightboxPan.style.transition = 'none';
            lightboxPan.style.transform = `translate3d(${deltaX * 0.32}px, 0, 0) scale(1)`;
            event.preventDefault();
          },
          { passive: false }
        );

        lightboxMedia.addEventListener(
          'touchend',
          (event) => {
            if (!lightbox || lightbox.hidden) return;

            if (pinchState && event.touches.length < 2) {
              pinchState = null;
              if (lightboxPan) {
                lightboxPan.classList.remove('is-dragging');
              }
              applyZoomState({ animate: false });
            }

            if (!touchDrag) return;

            if (lightboxPan) {
              lightboxPan.classList.remove('is-dragging');
            }

            if (zoomState.scale > 1.01) {
              applyZoomState({ animate: false });
            }

            if (touchDrag.gesture === 'swipe' && event.changedTouches.length === 1) {
              const touch = event.changedTouches[0];
              const deltaX = touch.clientX - touchDrag.startX;
              const deltaY = touch.clientY - touchDrag.startY;
              const swipeThreshold = clamp(lightboxMedia.clientWidth * 0.12, 48, 120);

              applyZoomState({ animate: true });

              if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
                event.preventDefault();
                stepLightbox(deltaX < 0 ? 1 : -1);
              }

              lastTapState.time = 0;
            } else if (!touchDrag.moved && event.changedTouches.length === 1) {
              const touch = event.changedTouches[0];
              const now = Date.now();
              const tapDistance = Math.hypot(touch.clientX - lastTapState.x, touch.clientY - lastTapState.y);

              if (now - lastTapState.time < 280 && tapDistance < 24) {
                event.preventDefault();
                toggleTapZoom();
                lastTapState.time = 0;
              } else {
                lastTapState = {
                  time: now,
                  x: touch.clientX,
                  y: touch.clientY,
                };
              }
            } else {
              lastTapState.time = 0;
            }

            touchDrag = null;
          },
          { passive: false }
        );

        lightboxMedia.addEventListener(
          'touchcancel',
          () => {
            touchDrag = null;
            pinchState = null;
            if (lightboxPan) {
              lightboxPan.classList.remove('is-dragging');
            }
            applyZoomState({ animate: false });
          },
          { passive: true }
        );
      }

      if (lightboxPan) {
        lightboxPan.addEventListener('pointerdown', (event) => {
          if (!lightbox || lightbox.hidden || event.pointerType === 'touch' || zoomState.scale <= 1.01) return;

          pointerDrag = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            originX: zoomState.x,
            originY: zoomState.y,
          };

          if (typeof lightboxPan.setPointerCapture === 'function') {
            lightboxPan.setPointerCapture(event.pointerId);
          }

          lightboxPan.classList.add('is-dragging');
          event.preventDefault();
        });

        lightboxPan.addEventListener('pointermove', (event) => {
          if (!pointerDrag || pointerDrag.pointerId !== event.pointerId) return;

          zoomState.x = pointerDrag.originX + (event.clientX - pointerDrag.startX);
          zoomState.y = pointerDrag.originY + (event.clientY - pointerDrag.startY);
          applyZoomState({ animate: false });
          event.preventDefault();
        });

        const stopPointerDrag = (event) => {
          if (!pointerDrag || pointerDrag.pointerId !== event.pointerId) return;

          if (typeof lightboxPan.releasePointerCapture === 'function') {
            try {
              lightboxPan.releasePointerCapture(event.pointerId);
            } catch (error) {
              // no-op
            }
          }

          lightboxPan.classList.remove('is-dragging');
          applyZoomState({ animate: false });
          pointerDrag = null;
        };

        lightboxPan.addEventListener('pointerup', stopPointerDrag);
        lightboxPan.addEventListener('pointercancel', stopPointerDrag);
        lightboxPan.addEventListener('pointerleave', stopPointerDrag);
      }

      openLightboxButtons.forEach((button) => {
        button.addEventListener('click', () => {
          openLightbox(getActiveMainIndex());
        });
      });

      lightboxCloseButtons.forEach((button) => {
        button.addEventListener('click', () => {
          closeLightbox();
        });
      });

      if (lightbox) {
        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox) {
            closeLightbox();
          }
        });
      }

      if (zoomInButton) {
        zoomInButton.addEventListener('click', () => {
          setLightboxZoom(zoomState.scale + 0.75);
        });
      }

      if (zoomOutButton) {
        zoomOutButton.addEventListener('click', () => {
          setLightboxZoom(zoomState.scale - 0.75);
        });
      }

      if (zoomResetButton) {
        zoomResetButton.addEventListener('click', () => {
          resetLightboxZoom({ animate: true });
        });
      }

      if (lightboxPrevButton) {
        lightboxPrevButton.addEventListener('click', () => {
          stepLightbox(-1);
        });
      }

      if (lightboxNextButton) {
        lightboxNextButton.addEventListener('click', () => {
          stepLightbox(1);
        });
      }

      const setActiveOffer = (card, updateUrl) => {
        if (!card) return;

        offerCards.forEach((item) => {
          const isActive = item === card;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (variantInput) {
          variantInput.value = card.dataset.variantId || '';
        }

        if (priceNode && card.dataset.price) {
          priceNode.textContent = card.dataset.price;
        }

        if (compareNode) {
          const hasDiscount = Number(card.dataset.discount || 0) > 0;
          if (hasDiscount && card.dataset.compare) {
            compareNode.textContent = card.dataset.compare;
            compareNode.classList.remove('is-hidden');
          } else {
            compareNode.textContent = '';
            compareNode.classList.add('is-hidden');
          }
        }

        if (discountNode) {
          const discountPercent = Number(card.dataset.discount || 0);
          if (discountPercent > 0) {
            discountNode.textContent = `-${discountPercent}%`;
            discountNode.classList.remove('is-hidden');
          } else {
            discountNode.textContent = '';
            discountNode.classList.add('is-hidden');
          }
        }

        if (submitButton) {
          const isAvailable = card.dataset.available === 'true';
          submitButton.disabled = !isAvailable;
          if (submitText) {
            const addLabel = submitButton.dataset.labelAdd || submitText.textContent || '';
            const soldLabel = submitButton.dataset.labelSold || addLabel;
            submitText.textContent = isAvailable ? addLabel : soldLabel;
          }
        }

        if (card.dataset.featuredMediaId) {
          slideToMedia(card.dataset.featuredMediaId);
        }

        if (updateUrl && card.dataset.variantId) {
          try {
            const params = new URLSearchParams(window.location.search);
            params.set('variant', card.dataset.variantId);
            const nextUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState({}, '', nextUrl);
          } catch (error) {
            // no-op
          }
        }
      };

      offerCards.forEach((card) => {
        card.addEventListener('click', () => {
          if (card.disabled) return;
          setActiveOffer(card, true);
        });
      });

      if (offerCards.length) {
        const initialActive =
          offerCards.find((card) => card.classList.contains('is-active') && !card.disabled) ||
          offerCards.find((card) => !card.disabled) ||
          offerCards[0];
        setActiveOffer(initialActive, false);
      }

      reviewAnchors.forEach((anchor) => {
        anchor.addEventListener('click', () => {
          const selector = anchor.dataset.tpScrollTarget || '#tp-pdp-reviews';
          const target = document.querySelector(selector);
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      accordions.forEach((accordion) => {
        const trigger = accordion.querySelector('[data-tp-accordion-trigger]');
        if (!trigger) return;

        setAccordionOpen(accordion, accordion.classList.contains('is-open'), true);

        trigger.addEventListener('click', () => {
          setAccordionOpen(accordion, !accordion.classList.contains('is-open'), false);
        });
      });

      window.addEventListener('resize', () => {
        accordions.forEach(syncAccordionHeight);

        if (lightbox && !lightbox.hidden) {
          applyZoomState({ animate: false });
        }
      });

      document.addEventListener('keydown', (event) => {
        if (!isLightboxOpen()) {
          if (event.key === 'Escape') {
            closeLightbox();
          }
          return;
        }

        if (event.key === 'Escape') {
          closeLightbox();
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          stepLightbox(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          stepLightbox(1);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTrackProMainProduct(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initTrackProMainProduct(event.target);
  });
})();
